<dt-modal-content (closeClick)="cancel()">
  <ng-template #title i18n>Veranstaltung löschen</ng-template>
  <ng-template #content>
    <p i18n
      >Du bist im Begriff die Veranstaltung „<span class="bold">{{ event.name }}</span
      >“ zu löschen. Dabei werden alle <span class="bold">{{ event.registrationCount }} Teilnehmer</span> aus der Veranstaltung entfernt und
      alle <span class="bold">{{ event.submissionCount }} Abgaben</span> gelöscht. Dies kann nicht rückgängig gemacht werden.</p
    >
    <p i18n>Bitte gib zur Bestätigung den Namen der Veranstaltung ein.</p>
    <mat-form-field>
      <mat-label i18n>Veranstaltungsname bestätigen</mat-label>
      <input matInput [formControl]="eventNameForm" />
      <mat-error i18n>Der Name stimmt nicht überein</mat-error>
    </mat-form-field>
  </ng-template>
  <ng-template #footer>
    <button
      mat-raised-button
      [disabled]="eventNameForm.invalid || eventNameForm.disabled"
      color="warn"
      (click)="delete()"
      [dtOverlayProgress]="eventNameForm.disabled"
      i18n
      >Veranstaltung löschen</button
    >
    <button mat-raised-button color="accent-less" [disabled]="eventNameForm.disabled" (click)="cancel()" i18n>Abbrechen</button>
  </ng-template>
</dt-modal-content>
